default_colors = { 0:'White', 1:'Navy', 2:'Scarlet', 3:'Columbia Blue', 4:'Grey' };
colors = {
     'Air Force Blue': '%23006699',
     'Black': '%23241f20', 
     'Brown': '%23333333', 
     'Bright Yellow': '%23ffff66',
     'Cardinal': '%23cc3333',
     'Columbia Blue': '%236699cc',
      'Cream': '%23FFFFCC',
     'Dark Gold': '%23ffcc33',
     'Dark Green': '%23005e35',
     'Dark Navy': '%23002a63',
     'Dark Royal': '%2300519c', 
     'Fuchsia': '%23ec549a',
     'Gold': '%23ffd700', 
     'Graphite': '%23454343', 
     'Grey': '%23b4b5b9',
     'Hot Pink': '%23ff006f',
     'Lavender': '%238a8ccd',
     'Lime': '%2333cc33',
     'Marlin Teal': '%2300aabe',
     'Maroon': '%23800000',
     'Navy': '%23003d7e',
     'Neon Green': '%234eb849',
     'Neon Yellow': '%23fef900',
     'Neon Orange': '%23ff4300',
     'Neon Gold': '%23fef900',
     'Old Gold': '%23dea200',
     'Orange': '%23ff6e00',
     'Pink': '%23ffadbf',
     'Purple': '%2338187f',
     'Royal': '%23005cb0',
     'Scarlet': '%23ff0000',
     'Sedona Red': '%23a80027',
     'Sky Blue': '%2387CEEB',
     'Royal Blue': '%234169E1',
     'Teal': '%23008587',
     'Tennessee Orange': '%23ff8b00',
     'Texas Orange': '%23d95400',
     'Turquoise': '%2300a0cf',
     'Vegas Gold': '%23dbd37d',
     'White': '%23FAFAFA',
     'Yellow': '%23fffb7d',
  'No Sock': '%23ffffff',
};

jQuery(document).ready(function() { 
  
  jQuery(".product_image img").each(function() {
    if (jQuery(this).attr('data-image')) {
        var cc = 'customerPhoto[' + jQuery(this).attr('data-image') + '],';
    } else {
        var cc = '';
    }
    for (i=1;i<11;i++) {
        if (!jQuery(this).attr('data-color-' + i)) break;
        cc = cc + 'color' + i.toString() + '[' + colors[jQuery(this).attr('data-color-' + i)] + '],';        
    }
    if (cc) jQuery(this).attr('src', "http://socks.liquifire.com/socks?set=" + cc + "style[" + jQuery(this).attr("data-title") + "]&call=url[%28%27file:socks/%27%20.%20%27global.style%27%29]&scale=size[140]&sink");
  });
});

jQuery(function(){
    jQuery('.product-qty input[data-min]').change(function(){
        if (parseInt(this.value) < parseInt(jQuery(this).attr('data-min'))) 
            this.value = jQuery(this).attr('data-min');
    });
});